import { useState, useRef } from "react";
// import VideoPlayer from "./VideoPlayer";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import ReactPlayer from "react-player";
import videoList from "./videoList";
import CustomLineChart from "./../CustomLineChart";
import data from "./data";
import PlayIcon from "@material-ui/icons/PlayArrowRounded";
import PauseIcon from "@material-ui/icons/PauseCircleFilledRounded";
import React from "react";

const DetailedScenarioVisualization = ({ testScenario, onBack }) => {
  const [currentVideoTime, setCurrentVideoTime] = useState(0);
  const [playing, setPlaying] = useState(false);
  const videoRefs = useRef([]);

  const handlePlay = () => {
    setPlaying(true);
  };

  const handlePause = () => {
    setPlaying(false);
  };

  const handleVideoTimeChange = (videoIndex, newTime) => {
    console.log("Video time altered from video number", videoIndex);
    setCurrentVideoTime(newTime);

    // Update the time for all videos
    videoRefs.current.forEach((ref, index) => {
      if (ref && index !== videoIndex) {
        ref.seekTo(newTime, "seconds"); // Access the seekTo method via the current property
      }
    });
  };

  const videoComponents = videoList.slice(0, 4).map((video, index) => (
    <Grid item xs={6} sm={3} style={{ marginTop: "10px" }}>
      <ReactPlayer
        ref={(ref) => (videoRefs.current[index] = ref)}
        url={video.url}
        playing={playing}
        onPlay={handlePlay}
        onPause={handlePause}
        controls
        width="90%"
        height="250px"
        progressInterval={1000}
      />
    </Grid>
  ));

  return (
    <div
      style={{ backgroundColor: "white", padding: "2%", overflowY: "hidden" }}
    >
      <Grid container spacing={3}>
        <Grid item xs={5}>
          <Button
            onClick={onBack}
            variant="contained"
            style={{
              backgroundColor: "#622AD8",
              color: "white",
              "&:hover": {
                backgroundColor: "#303f9f",
              },
              marginBottom: "10px",
            }}
          >
            Back
          </Button>
        </Grid>

        <Grid item xs={6}>
          <Button onClick={handlePlay} variant="contained" shape="circle" color="#622AD8">
            <PlayIcon />
            Play
          </Button>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={24}
        style={{ textAlign: "center", justifyContent: "center" }}
      >
        {/* <Grid item xs={3} sm={1}>
          <Button onClick={handlePlay} variant="contained" shape="circle">
            <PlayIcon />
            Play
          </Button>
        </Grid> */}
        {/* <Grid item xs={3} sm={1}>
          <Button
            variant="contained"
            onClick={handlePause}
            style={{ marginLeft: "10px" }}
          >
            <PauseIcon />
            Pause
          </Button>
        </Grid> */}

        <Grid container spacing={24}>
          {videoComponents}
        </Grid>
      </Grid>
      <br></br>
      <br></br>
      <Grid
        container
        spacing={24}
        style={{ textAlign: "center", justifyContent: "center" }}
      >
        <CustomLineChart
          // data={data.slice(0,200)}
          // data={data.slice(0, 200)}
          data={data}
          // title="Signal Data"
          columns={Object.keys(data[0])}
          selectedColumns={Object.keys(data[0])}
          keyPassed="date"
          filterType="checkbox"
          yLabelTitle="Count"
          // dateFormat="DD-MMM-YYYY"
        ></CustomLineChart>
      </Grid>
    </div>
  );
};

export default DetailedScenarioVisualization;
